import React from 'react';

import { RecipeSection } from '@ledium/types';
import { Box } from '@mui/material';

import SectionSegment from './SectionSegment';

interface RecipeTimelineProps {
    sectionList: RecipeSection[];
}

const RecipeTimeline = ({ sectionList }: RecipeTimelineProps) => {
    const sorted = sectionList.slice().sort((a, b) => a.orderPosition - b.orderPosition);

    const totalHours = sorted.reduce((sum, s) => sum + s.repeatNum * s.circadianLength, 0);

    if (totalHours === 0 || sorted.length === 0) {
        return null;
    }

    return (
        <Box sx={{ display: 'flex', height: 20, gap: 0.5, borderRadius: 1, overflow: 'visible', width: '100%' }}>
            {sorted.map((section) => (
                <SectionSegment key={section.id} section={section} widthPercent={((section.repeatNum * section.circadianLength) / totalHours) * 100} />
            ))}
        </Box>
    );
};

export default React.memo(RecipeTimeline);
